import type { InferenceModelType } from "@kuzco/models";

import { MODEL_PRICE_PER_TOKEN_IN_HOGANS_MAP } from "../pricing/ModelPricing";

function getTokenPricing(model: InferenceModelType) {
  const pricing = MODEL_PRICE_PER_TOKEN_IN_HOGANS_MAP[model];
  if (!pricing) {
    throw new Error(`No pricing found for model: ${model}`);
  }
  return pricing;
}

export function getPromptPricePerTokenInHogansForModel(
  model: InferenceModelType,
): bigint {
  return getTokenPricing(model).promptTokenPrice;
}

export function getCompletionPricePerTokenInHogansForModel(
  model: InferenceModelType,
): bigint {
  return getTokenPricing(model).completionTokenPrice;
}

export function getPromptHogansPricePerMillionTokens(
  model: InferenceModelType,
): bigint {
  return getPromptPricePerTokenInHogansForModel(model) * 1_000_000n;
}

export function getCompletionHogansPricePerMillionTokens(
  model: InferenceModelType,
): bigint {
  return getCompletionPricePerTokenInHogansForModel(model) * 1_000_000n;
}

export const ModelPricingUtils = {
  getPromptPricePerTokenInHogansForModel,
  getCompletionPricePerTokenInHogansForModel,
  getPromptHogansPricePerMillionTokens,
  getCompletionHogansPricePerMillionTokens,
};
